<div class="col-sm-6 pdr5 train-information-div">
	<div class="content-heading text-uppercase">
		<h3>{{trainLabel?.trainInformation}}</h3>
	</div>
	<div class="row">
		<p class="train-name-details"><label> {{trainLabel?.trainName}}: </label>
			<b>{{trainData?.trainName? trainData?.trainName : '-'}}</b></p>

		<div class="col-sm-6 pdr5">
			<div class="list-content">
				<ul class="list-unstyled">
						<li>
								<label> {{trainLabel?.calledTime}}: </label>
								<b>{{trainData?.callDateTime? trainData?.callDateTime : '-'}}</b>
							</li>
					<li>
						<label> {{trainLabel?.projectedTonnage}}: </label>
						<b>{{trainData?.projectedTons? trainData?.projectedTons : '-'}}</b>
					</li>
					<li>
						<div class="last-reporting">
							<label> {{trainLabel?.lastReporting}}: </label>
							<span>
								<b *ngIf="returnDash([trainData?.lastReportingCityState,trainData?.lastReportingSource,trainData?.lastReportingMilepost,trainData?.lastReportingDateTime])">-</b>
								<b *ngIf="!returnDash([trainData?.lastReportingCityState,trainData?.lastReportingSource,trainData?.lastReportingMilepost, trainData?.lastReportingDateTime])">
								{{(trainData?.lastReportingCityState ? trainData?.lastReportingCityState + ', ' : '')}} {{trainData?.lastReportingMilepost}} {{trainData?.lastReportingSource}} {{ trainData?.lastReportingDateTime}}
								</b>
							</span>
						</div>
					</li>
					
				</ul>
			</div>
		</div>

		<div class="col-sm-6 pdr5">
			<div class="list-content">
				<ul class="list-unstyled">
					<li>
							<label> {{trainLabel?.departed}}: </label>
							<b>{{trainData?.departDateTime? trainData?.departDateTime : '-'}}</b>
					</li>
					<li>
						<label> {{trainLabel?.lastReported}}: </label>
						<b>{{trainData?.lastReportingDateTime? trainData?.lastReportingDateTime : '-'}}</b>
					</li>
					<li>
						<label> {{trainLabel?.hoursNotMoved}}: </label>
						<b>{{trainData?.hoursNotMoved? trainData?.hoursNotMoved : '-'}}</b>
					</li>		
				</ul>
			</div>
		</div>

	</div>
</div>